<template>
	<el-container>
	  <el-header height="48px">
			<div class="nav-content">
				<div class="content-left">
					<img src="@/assets/images/nav/logo.png" alt="" class="nav-logo">
					<div class="nav-list" v-if="!onlyIcon">
						<div class="nav-item" v-for="(item,index) in navList" :key="index" >
							<router-link :to="item.url">
								<span :class="index == navIndex ? 'nav-active' : 'col-fff'">{{item.name}}</span>
							</router-link>
						</div>
					</div>
				</div>
				<div v-if="!onlyIcon">
					<router-link to="/" v-if="!isLogin">
						<div class="un-login col-fff">
							登录/注册
						</div>
					</router-link>
					<div class="user-msg col-fff" v-if="isLogin">
						<el-badge :value="2" :max="99" class="">
							<router-link to="/personal">
								<span class="msg-item col-fff">消息</span>
							</router-link>
						</el-badge>
						<router-link to="/personal">
							<span class="msg-item col-fff">简历</span>
						</router-link>
						<div class="msg-name col-fff">{{userMsg.name||''}}</div>
						<router-link to="/personal">
							<img src="@/assets/images/nav/tx-n.png" class="msg-img" alt="">
						</router-link>
					</div>
				</div>
			</div>
		</el-header>
		<el-main>
			<slot></slot>
		</el-main>
	  <el-footer height="312px" v-if="!onlyIcon">
			<div class="footer-content">
				<div class="footer-msg">
					<div class="flex">
						<div class="flex-item">
							<div class="flex-title">
								企业服务
							</div>
							<router-link to="">
								<div class="footer-font mt-20">
									职位搜索
								</div>
							</router-link>
							<router-link to="">
								<div class="footer-font mt-8">
									新闻资讯
								</div>
							</router-link>
							<router-link to="">
								<div class="footer-font mt-8">
									咚咚匠APP
								</div>
							</router-link>
							<router-link to="">
								<div class="footer-font mt-8">
									企业服务
								</div>
							</router-link>
						</div>
						<div class="flex-item">
							<div class="flex-title">
								使用与帮助
							</div>
							<router-link to="">
								<div class="footer-font mt-20">
									协议与规则
								</div>
							</router-link>
							<router-link to="">
								<div class="footer-font mt-8">
									隐私政策
								</div>
							</router-link>
							<router-link to="">
								<div class="footer-font mt-8">
									防诈骗指南
								</div>
							</router-link>
							<router-link to="">
								<div class="footer-font mt-8">
									使用帮助
								</div>
							</router-link>
							<router-link to="">
								<div class="footer-font mt-8">
									联系客服
								</div>
							</router-link>
						</div>
						<div>
							<div class="flex-title">
								联系咚咚匠
							</div>
							<router-link to="">
								<div class="footer-font mt-20">
									北京咚咚匠网络技术有限公司
								</div>
							</router-link>
							<router-link to="">
								<div class="footer-font mt-8">
									公司地址：xxxxxxxxxxxxxxxxxxxxxxxx
								</div>
							</router-link>
							<router-link to="">
								<div class="footer-font mt-8">
									投诉邮箱：xxxxxxxxxxxxxxxxxxxxxxxx
								</div>
							</router-link>
						</div>
					</div>
					<div class="text-r">
						<img src="@/assets/images/nav/logo.png" alt="" class="footer-logo">
						<div class="footer-font mt-20">联系电话：400 xxx xxx</div>
						<div class="footer-font mt-8">工作日：08:00 - 22:00</div>
						<div class="flex mt-82">
							<div class="channel-item" v-for="(item,index) in channelList" :key="index">
								<img :src="item.icon" alt="" class="channel-icon">
								<div class="footer-font mt-8">
									{{item.name}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="footer-font footer-file">
					备案信息：xxxxxxxxxxxxxxxxxxxxxx
				</div>
			</div>
		</el-footer>
	</el-container>
</template>

<script>
	export default{
		data(){
			return{
				navList:[
					{name:'首页',url:'/'},
					{name:'岗位需求',url:'/job'},
					{name:'课程资源',url:'/course'},
					{name:'工具服务',url:''},
					{name:'政策资讯',url:'/news'},
					{name:'数据服务',url:''},
				],
				isLogin:true,
				userMsg:{
					name:'林子豪'
				},
				channelList:[
					{
						name:'微博',
						icon:require('@/assets/images/nav/wb@2x.png')
					},
					{
						name:'微信',
						icon:require('@/assets/images/nav/wx@2x.png')
					},
					{
						name:'安卓 APP',
						icon:require('@/assets/images/nav/Android@2x.png')
					},
					{
						name:'Ios APP',
						icon:require('@/assets/images/nav/IOS@2x.png')
					},
				],
			}
		},
		props:{
			navIndex:{
				type:[String,Number],
				default:0
			},
			onlyIcon:{
				type:Boolean,
				default:false
			}
		}
	}
</script>

<style>
	.el-header{
		background: #020E27;
		height: 48px;
		position: fixed;
		width: 100%;
		z-index: 999;
	}
	.el-main{
		padding: 48px 0 0 0;
	}
	.el-main::-webkit-scrollbar{
		display: none;
	}
	.nav-content{
		width: 1280px;
		margin: auto;
		padding: 0 20px 0 18px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 100%;
	}
	.content-left{
		display: flex;
		align-items: center;
	}
	.nav-logo{
		width: 93px;
		height: 26px;
	}
	.nav-list{
		display: flex;
		align-items: center;
		margin-left: 26px;
	}
	.nav-item{
		font-size: 14px;
		margin-right: 20px;
		font-weight: bold;
		cursor: pointer;
	}
	.nav-active,.nav-item:hover span{
		color: #169BD5 !important;
	}
	.un-login{
		width: 90px;
		height: 22px;
		border-radius: 4px;
		background: #169BD5;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
		line-height: 13px;
	}
	.user-msg{
		display: flex;
		align-items: center;
		font-weight: bold;
		font-size: 14px;
	}
	.msg-item{
		margin-left: 24px;
	}
	.msg-name{
		margin-left: 24px;
	}
	.msg-img{
		margin-left: 12px;
		width: 26px;
		height: 26px;
		border-radius: 50%;
	}
	.el-footer{
		background: #313438;
	}
	.footer-content{
		width: 1280px;
		margin: auto;
		padding: 25px 20px 0 20px;
		height: 100%;
		box-sizing: border-box;
		position: relative;
	}
	.footer-logo{
		width: 61px;
		height: 17px;
	}
	.footer-msg{
		display: flex;
		justify-content: space-between;
	}
	.text-r{
		text-align: right;
	}
	.col-fff{
		color: #fff !important;
	}
	.footer-font{
		font-size: 13px;
		line-height: 18px;
		color:#8F9092;
	}
	.mt-20{
		margin-top: 20px;
	}
	.mt-8{
		margin-top: 8px;
	}
	.flex{
		display: flex;
	}
	.flex-item{
		width: 200px;
	}
	.flex-title{
		font-size: 16px;
		line-height: 22px;
		color: #C7C7C9;
	}
	.footer-file{
		position: absolute;
		left: 20px;
		bottom: 32px;
	}
	.mt-82{
		margin-top: 82px;
	}
	.channel-item{
		width: 70px;
		text-align: center;
	}
	.channel-icon{
		width: 42px;
		height: 42px;
	}
</style>